var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496 392v80a24 24 0 0 1 -24 24h-432a24 24 0 0 1 -24-24v-80",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 72v40h-480v-40a24.006 24.006 0 0 1 24-24h432a24.006 24.006 0 0 1 24 24z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 112v312a24.006 24.006 0 0 1 -24 24h-432a24.006 24.006 0 0 1 -24-24v-312z",
    fill: "#e0e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 16h48v64h-48z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 16h48v64h-48z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 16h48v64h-48z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 224,
    fill: "#ffda44",
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m407.598 184.402-5.657 5.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.059 257.941-5.657 5.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.598 263.598-5.657-5.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.059 190.059-5.657-5.657"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m152 323s-48-24-72-16c0 0 24-40 64-24 0 0 16-56 72-32 0 0-32 16-32 32 0 0 32-8 48 24 0 0-64 0-80 16z",
    fill: "#91cc04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.78 405h-26.78s6-68.05 23.22-89.3l24.78 1.3s0 80 8 88h-32",
    fill: "#a0815c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.78 405a72.025 72.025 0 0 1 140.44 0",
    fill: "#ff9811"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m472 40h-24v-24a8 8 0 0 0 -8-8h-48a8 8 0 0 0 -8 8v24h-96v-24a8 8 0 0 0 -8-8h-48a8 8 0 0 0 -8 8v24h-96v-24a8 8 0 0 0 -8-8h-48a8 8 0 0 0 -8 8v24h-24a32.03 32.03 0 0 0 -32 32v400a32.03 32.03 0 0 0 32 32h432a32.036 32.036 0 0 0 32-32v-400a32.036 32.036 0 0 0 -32-32zm-72-16h32v48h-32zm-160 0h32v48h-32zm-160 0h32v48h-32zm408 448a16.021 16.021 0 0 1 -16 16h-432a16.021 16.021 0 0 1 -16-16v-20.3a31.8 31.8 0 0 0 16 4.3h432a31.705 31.705 0 0 0 16-4.31zm0-48a16.021 16.021 0 0 1 -16 16h-432a16.021 16.021 0 0 1 -16-16v-304h464zm0-320h-464v-32a16.021 16.021 0 0 1 16-16h24v24a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-24h96v24a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-24h96v24a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-24h24a16.021 16.021 0 0 1 16 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424 400h-138.67a79.98 79.98 0 0 0 -116.09-45.4c-.7-12.65-.31-22.72 1.16-29.34 16.82-5.18 44.08-7.25 61.6-7.26a8 8 0 0 0 7.16-11.58c-10.55-21.09-28.09-28.09-42.14-29.23 5.65-5.94 15.05-12.26 22.56-16.03a8 8 0 0 0 -.43-14.51c-19.15-8.21-36.35-8.82-51.1-1.8-15.92 7.57-24.67 22.16-28.77 31.19-16.4-4.26-32.51-1.04-46.99 9.49a77.263 77.263 0 0 0 -19.15 20.35 8 8 0 0 0 9.39 11.71c9.9-3.3 26.25.36 40.7 5.24-5.46 10.76-10.13 26.51-13.94 47.03-2.26 12.17-3.71 23.24-4.5 30.14h-48.79a8 8 0 0 0 0 16h368a8 8 0 0 0 0-16zm-325.23-99.24c1.05-.87 2.15-1.74 3.33-2.57 12.11-8.65 25.21-10.25 38.93-4.76a8.007 8.007 0 0 0 10.66-5.23c.06-.21 6.38-20.89 23.23-28.9 6.36-3.03 13.59-3.95 21.6-2.77-9.92 7.22-20.52 17.69-20.52 29.47a8.024 8.024 0 0 0 9.89 7.77 38.085 38.085 0 0 1 15.1.19 32.129 32.129 0 0 1 15.92 8.5c-5.7.3-12.57.79-19.79 1.59-21.87 2.43-37.07 6.56-46.17 12.58-9.8-4.52-32.06-13.89-52.18-15.87zm33.9 99.24h-11.79c2.38-20.09 8.1-54.74 17.39-71.46 4.11 1.73 7.62 3.35 10.15 4.62a7.84 7.84 0 0 0 4.78.74 210.745 210.745 0 0 0 .83 32 80.424 80.424 0 0 0 -21.36 34.1zm17 0a64.452 64.452 0 0 1 19.13-25.8 64 64 0 0 1 80.4 0 64.452 64.452 0 0 1 19.13 25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448 416h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 256a32 32 0 1 0 -32-32 32.036 32.036 0 0 0 32 32zm0-48a16 16 0 1 1 -16 16 16.019 16.019 0 0 1 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 184a8 8 0 0 0 8-8v-8a8 8 0 0 0 -16 0v8a8 8 0 0 0 8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 272v8a8 8 0 0 0 16 0v-8a8 8 0 0 0 -16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 224a8 8 0 0 0 8 8h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312 232h8a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.941 198.059a7.973 7.973 0 0 0 5.658-2.344l5.656-5.657a8 8 0 0 0 -11.315-11.312l-5.656 5.657a8 8 0 0 0 5.657 13.656z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.4 252.285-5.656 5.657a8 8 0 1 0 11.315 11.312l5.656-5.657a8 8 0 0 0 -11.315-11.312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.285 252.284a8 8 0 0 0 0 11.313l5.656 5.657a8 8 0 0 0 11.315-11.312l-5.656-5.657a8 8 0 0 0 -11.315-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.4 195.715a8 8 0 0 0 11.316-11.315l-5.656-5.657a8 8 0 0 0 -11.315 11.312z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f6781459916cfd09437538426c459d18.svg";
export { ForwardRef as ReactComponent };